import { TCommentType } from '@entities/comment/model/types';
import { routes } from '@shared/api/routes';

export const getCommentsPollingRoute = ({
    commentType,
    estimateId,
}: {
    commentType: TCommentType;
    estimateId: string;
}): string => {
    if (commentType === 'excessComment') {
        return routes.getUnreadExcessCommentListUrl({ _estimateId_: estimateId });
    }
    if (commentType === 'extraWorkComment') {
        return routes.getUnreadWorkCommentListUrl({ _estimateId_: estimateId });
    }

    return routes.getUnreadCommentsUrl({ _estimateId_: estimateId });
};
